// @flow
import styled from 'styled-components';

export const ErrorMessage = styled.div`
  display: block;
  margin: 20px 0px;
`;



// WEBPACK FOOTER //
// ./src/components/graphql-errors/graphql-errors.styles.js